<ng-container *ngIf="isLoaded">
    <div class="row banner banner-project"
         [ngStyle]="{
             'background': 'linear-gradient( rgba(19, 49, 66, 0.60), rgba(1, 1, 28, 0.60))'
                 + ', url(/assets/project-images/'+ project.banner
                 + ') no-repeat center center',
             'background-size': 'cover'
          }">
        <div class="col-md-7 col-lg-5 justify-content-center align-self-center">
            <h1 [innerHtml]="project.title | filterHTML"></h1>
            <p>
                {{ project.description }}
            </p>
            <a routerLink="/projects" class="btn btn-default">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
                back to projects
            </a>
        </div>
        <a (click)="scrollService.scroll(content)" class="btn-go">
            <i class="fa fa-angle-down" aria-hidden="true"></i>
        </a>
    </div>
    <span #content></span>
    <app-building-block class="row" *ngFor="let block of project.buildingBlocks"
                        [context]="block.context" [type]="block.name"
                        [requiresPadding]="true"
    ></app-building-block>
    <div class="row cta-box text-center">
        <div class="col-md-12">
            <h2>Want to start your project with us?</h2>
            <h3>Let's talk &amp; have a coffee together.</h3>
            <a routerLink="/contact" class="btn btn-primary">Contact us</a>
        </div>
    </div>
    <footer class="row">
        <div class="col-md-12 d-block d-sm-flex justify-content-between">
            <div class="align-self-start">
                <p>Mercit is een product van <strong>Techventures</strong></p>
                <ul>
                    <li>
                        <a href="tel:0032051730083">
                            <i class="fa fa-phone" aria-hidden="true"></i>(+32) 051 73 00 83
                        </a>
                    </li>
                    <li>
                        <a href="mailto:info@mercit.be">
                            <i class="fa fa-comment-o" aria-hidden="true"></i>info@mercit.be
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <i class="fa fa-location-arrow" aria-hidden="true"></i>
                            Joremaaie 3, B-9000 Ghent
                        </a>
                    </li>
                </ul>
            </div>
            <div class="align-self-center align-items-end">
                <a href="https://www.linkedin.com/company/10512483/" target="_blank">
                    <i class="fa fa-linkedin" aria-hidden="true"></i>
                </a>
                <a href="https://www.facebook.com/Mercitbe/?ref=br_rs" target="_blank">
                    <i class="fa fa-facebook" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </footer>
</ng-container>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/detail/detail.component.html